import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'

export const Wrapper = styled.div.attrs({
  'data-at-appointment-vehicle': true
})`
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('width', '16.28em', '9.72em')}
  ${Mixin.responsive('height', '14.29em', '9.72em')}
  ${Mixin.responsive('padding', '20px', '10px')}
  ${Mixin.responsive('margin', '0 12px', '0 8px 16px')}
  ${props => props.active && css`
    border: 2px solid ${Theme.colors.dark_grey};
    box-shadow: 0 1px 4px ${Theme.colors.transparent_overlay_shadow};
  `}
`

export const ButtonWrapper = styled(Wrapper.withComponent('button'))`
  background: ${Theme.colors.white};
  text-align: left;
`

export const Logo = styled.div`
  text-align: center;
  ${Mixin.responsive('height', '7.36em', '4.86em')}
  ${Mixin.middle()}
`

export const Name = styled.div`
  font-weight: 600;
  ${Mixin.responsive('font-size', '18px', '14px')}
  ${Mixin.responsive('min-height', '50px', '40px')}
`
